export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9454.404366d1.jpg";